export default {"src":"/_next/static/media/font_bold.ad69ae3d.svg","height":24,"width":24};